import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

// Format currency with 2 decimal places for display
export function formatCurrency(amount: number): string {
  return amount.toLocaleString('en-US', { 
    minimumFractionDigits: 2, 
    maximumFractionDigits: 2 
  });
}

// Format currency with Rs. prefix for summary displays
export function formatCurrencyWithSymbol(amount: number): string {
  return `Rs. ${formatCurrency(amount)}`;
}

// Format date for input fields without timezone conversion
export function formatDateForInput(year: number, month: number, day: number = 1): string {
  return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
}

// Get today's date in local timezone as YYYY-MM-DD
export function getTodayDateString(): string {
  const today = new Date();
  return formatDateForInput(today.getFullYear(), today.getMonth() + 1, today.getDate());
}

// Get last day of a month
export function getLastDayOfMonth(year: number, month: number): number {
  return new Date(year, month, 0).getDate();
}

// Get number of working days (Monday to Saturday) in a month
export function getWorkingDaysInMonth(year: number, month: number): number {
  const lastDay = getLastDayOfMonth(year, month);
  let workingDays = 0;
  
  for (let day = 1; day <= lastDay; day++) {
    const date = new Date(year, month - 1, day);
    const dayOfWeek = date.getDay(); // 0 = Sunday, 6 = Saturday
    if (dayOfWeek !== 0) { // Exclude Sunday only
      workingDays++;
    }
  }
  
  return workingDays;
}
